import script from "./DoubleNoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubleNoDetail.vue?vue&type=script&setup=true&lang=js"

import "./DoubleNoDetail.vue?vue&type=style&index=0&id=383e3e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383e3e46"]])

export default __exports__